
import { AreaChart, Area, PieChart, Pie, Cell } from "recharts"
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar } from 'recharts';
// import './dashboard-charts.css'

// const courseCompletionData = [
//   { month: "January", completion: 75 },
//   { month: "February", completion: 45 },
//   { month: "March", completion: 65 },
//   { month: "April", completion: 35 },
//   { month: "May", completion: 80 },
//   { month: "June", completion: 95 },
// ]

// Data for Rebooking Rate Donut - 45% as shown in image
const rebookingData = [
  { name: "Rebooked", value: 90, fill: "#00A900" }, // Bright green
  { name: "Not Rebooked", value: 10, fill: "#A6B9DA" }, // Light blue
]
const MONTH_MAP = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { label, value } = payload[0].payload;
    return (
      <div style={{ background: '#fff', padding: '8px', border: '1px solid #ccc' }}>
        <p><strong>Month:</strong> {MONTH_MAP[label]}</p>
        <p><strong>Value:</strong> {value}</p>
      </div>
    );
  }
  return null;
};
// Custom gauge component for Monthly Visitors
const GaugeChart = ({ value, total }) => {
  const percentage = (value / total) * 100;
  const angle = (percentage / 100) * 180; // max 180 for semi-circle
  const radius = 80;
  const cx = 100;
  const cy = 100;

  // Convert angle to coordinates
  const x = cx + radius * Math.cos(Math.PI * (1 - percentage / 100));
  const y = cy - radius * Math.sin(Math.PI * (percentage / 100));

  const largeArcFlag = percentage > 50 ? 1 : 0;
  const strokeDasharray = `${percentage * 2.51} 251`;

  return (
    <div className="gauge-container" style={{ position: 'relative', width: '200px', height: '120px' }}>
      <svg width="200" height="120" viewBox="0 0 200 120">
        {/* Background Arc */}
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="#E5E7EB"
          strokeWidth="10"
        />

        {/* Foreground Arc */}
        <path
          d={`M 20 100 A 80 80 0 ${largeArcFlag} 1 ${x} ${y}`}
          fill="none"
          stroke="#72675B"
          strokeWidth="10"
          strokeLinecap="round"
        />

        {/* End dot */}
        <circle cx={x} cy={y} r="7" fill="#72675B" stroke="white" strokeWidth="3" />
      </svg>

      {/* Center Text */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -40%)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '28px', fontWeight: '600' }}>{value}</div>
        <div style={{ fontSize: '14px', color: '#4B5563' }}>New Policy Updates</div>
      </div>
    </div>
  );
};

export default function DashboardCharts({ userData }) {
  // console.log("akjsfkjasdfa",userData)
  //  const userData = {
  //  productSoldMonthly: [
  //     { month: 0, value: 0 },
  //     { month: 1, value: 3 },
  //     { month: 2, value: 6 },
  //     { month: 3, value: 9 },
  //     { month: 4, value: 13 },
  //     { month: 5, value: 16 },
  //     { month: 6, value: 18 },
  //   ],
  // const membershipSoldMonthly = [
  //   { label: '1', value: 3 },
  //   { label: '2', value: 2 },
  //   { label: '3', value: 10 },
  //   { label: '4', value: 4 },
  //   { label: '5', value: 0 },
  //   { label: '6', value: 2 },
  //   { label: '7', value: 0 }, // highlighted
  //   { label: '8', value: 4 },
  // ]
  // };
  const maxValue = userData && Math.max(...userData?.membershipSoldMonthly.map((item) => item.value));
const maxValueMonthly = userData && Math.max(...userData.productSoldMonthly.map(item => item.value));
const yAxisMax = maxValueMonthly && Math.ceil(maxValueMonthly * 2); // Double the max value, rounded up

// Generate up to 6 tick values (including 0 and yAxisMax)
const tickCount = 6;
const ticks = Array.from({ length: tickCount }, (_, i) => Math.round((yAxisMax / (tickCount - 1)) * i));

  return (
    <div className="dashboard-container dashboard-wrapper">
      <div className="charts-row">
        {/* Course Completion Chart */}
        {userData?.productSoldMonthly && (
          <div className="chart-card">
            <div className="chart-header">
              <div>
                <h3 className="chart-title">Products sold (Monthly)</h3>
                <div className="visitors-stats">
                  {/* <span className="visitors-number">2,648K</span> */}
                  <span className="visitors-growth">{userData?.productSolds}</span>
                </div>
              </div>
            </div>
            <div className="chart-content">
              <ResponsiveContainer width="100%" height={200}>
                <LineChart
                  data={userData.productSoldMonthly}
                  margin={{ top: 10, right: 20, bottom: 0, left: 10 }}
                >
                  {/* Gradient Line */}
                  <defs>
                    <linearGradient id="lineGradient" x1="0" y1="0" x2="1" y2="0">
                      <stop offset="0%" stopColor="#3B82F6" />
                      <stop offset="100%" stopColor="#10B981" />
                    </linearGradient>
                  </defs>

                  {/* Grid Lines */}
                  <CartesianGrid vertical stroke="#E5E7EB" strokeDasharray="3 3" />

                  {/* X-Axis */}
                  <XAxis
                    dataKey="month"
                    tick={{ fontSize: 12, fill: "#374151" }}
                    axisLine={{ stroke: "#000000" }}
                    tickLine={false}
                  />

                  {/* Y-Axis */}
                  {/* <YAxis
                    domain={[0, 20]}
                    ticks={[0, 5, 10, 15, 20]}
                    tick={{ fontSize: 12, fill: "#374151" }}
                    axisLine={{ stroke: "#000000" }}
                    tickLine={false}
                  /> */}
                  <YAxis
                    domain={[0, yAxisMax]}
                    ticks={ticks}
                    tick={{ fontSize: 12, fill: "#374151" }}
                    axisLine={{ stroke: "#000000" }}
                    tickLine={false}
                  />
                  <Tooltip
                        contentStyle={{ backgroundColor: 'white', border: '1px solid #ccc', fontSize: 12 }}
                        labelStyle={{ color: '#6B7280' }} // Gray-500
                        cursor={{ stroke: '#10B981', strokeWidth: 1 }}
                      />
                  {/* Line */}
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="url(#lineGradient)"
                    strokeWidth={3}
                    dot={{ r: 4, fill: 'white', stroke: '#10B981', strokeWidth: 2 }}
                    isAnimationActive={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        )}

        {/* Memberships Sold Monthly */}
        <div className="chart-card">
          <div className="chart-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <h3 className="chart-title">Membership Sold (monthly)</h3>
              {/* <div style={{ fontSize: '24px', fontWeight: '600' }}>5</div> */}
              <div className="visitors-stats">
                {/* <span className="visitors-number">2,648K</span> */}
                <span className="visitors-growth">{userData?.membershipSolds}</span>
              </div>


            </div>
            {/* <div style={{ fontSize: '12px', color: '#9CA3AF' }}>Last 3 days</div> */}
          </div>
          <div className="chart-content" style={{ height: 200 }}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={userData && userData?.membershipSoldMonthly} margin={{ top: 20, left: 0, right: 0, bottom: 0 }}>
                <XAxis dataKey="label" axisLine={false} tickLine={false} />
                <YAxis hide domain={[0, 'dataMax + 2']} />
                {/* <Tooltip cursor={{ fill: 'transparent' }} /> */}
                <Tooltip content={<CustomTooltip />} cursor={{ fill: 'transparent' }} />

                <Bar dataKey="value" radius={[4, 4, 0, 0]} isAnimationActive={false} minPointSize={3}>
                  {userData && userData?.membershipSoldMonthly.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.value === maxValue && maxValue > 0 ? '#72675B' : '#D9D9D9'}
                    />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Rebooking Rate Donut Chart */}
        <div className="chart-card">
          <div>
            <h3 className="chart-title">Rebooking Rate</h3>
            <div className="visitors-stats">
              {/* <span className="visitors-number">2,648K</span> */}
              <span className="visitors-growth">{userData?.averageRatings}%</span>
            </div>
          </div>
          <div className="chart-content donut-content">
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={[
                    { name: "Rebooked", value: Number(userData?.averageRatings), fill: "#00A900" }, // Bright green
                    { name: "Not Rebooked", value: 100 - Number(userData?.averageRatings), fill: "#A6B9DA" }, // Light blue
                  ]}
                  cx="50%"
                  cy="50%"
                  innerRadius={50}
                  outerRadius={80}
                  startAngle={90}
                  endAngle={450}
                  dataKey="value"
                  stroke="none"
                >
                  {[
                    { name: "Rebooked", value: Number(userData?.averageRatings), fill: "#00A900" }, // Bright green
                    { name: "Not Rebooked", value: 100 - Number(userData?.averageRatings), fill: "#A6B9DA" }, // Light blue
                  ].map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
            <div className="donut-center">
              <div className="donut-number">{userData?.averageRatings}%</div>
              {/* <div className="donut-label">Sales increased by 10%</div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
